import React from 'react';
import FaqDetailBannerSC from './faq-detail-banner.styled';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';
import { ReactComponent as LeftArrow } from '../../assets/img/svg/left-arrow.svg';
import { Link } from 'react-router-dom';
import { ROUTE_FAQ } from '../../constants';

const FaqDetailBanner = () => {
  return (
    <FaqDetailBannerSC>
      <div className="left-wrap">
        <Link className="back-to-faq" to={ROUTE_FAQ}>
          <LeftArrow />
          <FormattedMessage id="faq_banner_headline" defaultMessage={dlt['faq_banner_headline']} />
        </Link>
      </div>
    </FaqDetailBannerSC>
  );
};

export default withRouter(FaqDetailBanner);
